'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errcode = require('err-code');

var pTimeout = require('p-timeout');

var _require = require('uint8arrays/equals'),
    uint8ArrayEquals = _require.equals;

var _require2 = require('uint8arrays/to-string'),
    uint8ArrayToString = _require2.toString;

var libp2pRecord = require('libp2p-record');

var c = require('../constants');

var Query = require('../query');

var utils = require('../utils');

var Record = libp2pRecord.Record;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('../query').DHTQueryResult} DHTQueryResult
 */

/**
 * @param {import('../')} dht
 */

module.exports = function (dht) {
  /**
   * @param {Uint8Array} key
   * @param {Uint8Array} rec
   */
  var putLocal = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, rec) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dht.datastore.put(utils.bufferToKey(key), rec));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function putLocal(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * Attempt to retrieve the value for the given key from
   * the local datastore.
   *
   * @param {Uint8Array} key
   */


  var getLocal = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
      var raw, rec;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dht._log("getLocal ".concat(uint8ArrayToString(key, 'base32')));

              _context2.next = 3;
              return dht.datastore.get(utils.bufferToKey(key));

            case 3:
              raw = _context2.sent;

              dht._log("found ".concat(uint8ArrayToString(key, 'base32'), " in local datastore"));

              rec = Record.deserialize(raw);
              _context2.next = 8;
              return dht._verifyRecordLocally(rec);

            case 8:
              return _context2.abrupt("return", rec);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getLocal(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Send the best record found to any peers that have an out of date record.
   *
   * @param {Uint8Array} key
   * @param {import('../query').DHTQueryValue[]} vals - values retrieved from the DHT
   * @param {Uint8Array} best - the best record that was found
   */


  var sendCorrectionRecord = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key, vals, best) {
      var fixupRec;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return utils.createPutRecord(key, best);

            case 2:
              fixupRec = _context4.sent;
              return _context4.abrupt("return", Promise.all(vals.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(v) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!uint8ArrayEquals(v.val, best)) {
                            _context3.next = 2;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 2:
                          if (!dht._isSelf(v.from)) {
                            _context3.next = 12;
                            break;
                          }

                          _context3.prev = 3;
                          _context3.next = 6;
                          return dht._putLocal(key, fixupRec);

                        case 6:
                          _context3.next = 11;
                          break;

                        case 8:
                          _context3.prev = 8;
                          _context3.t0 = _context3["catch"](3);

                          dht._log.error('Failed error correcting self', _context3.t0);

                        case 11:
                          return _context3.abrupt("return");

                        case 12:
                          _context3.prev = 12;
                          _context3.next = 15;
                          return dht._putValueToPeer(key, fixupRec, v.from);

                        case 15:
                          _context3.next = 20;
                          break;

                        case 17:
                          _context3.prev = 17;
                          _context3.t1 = _context3["catch"](12);

                          dht._log.error('Failed error correcting entry', _context3.t1);

                        case 20:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[3, 8], [12, 17]]);
                }));

                return function (_x7) {
                  return _ref4.apply(this, arguments);
                };
              }())));

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function sendCorrectionRecord(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    /**
     * Store the given key/value pair locally, in the datastore.
     *
     * @param {Uint8Array} key
     * @param {Uint8Array} rec - encoded record
     */
    _putLocal: function _putLocal(key, rec) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", putLocal(key, rec));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * Store the given key/value  pair in the DHT.
     *
     * @param {Uint8Array} key
     * @param {Uint8Array} value
     * @param {object} [options] - put options
     * @param {number} [options.minPeers] - minimum number of peers required to successfully put (default: closestPeers.length)
     */
    put: function put(key, value) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var options, record, counterAll, counterSuccess, minPeers, error;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};

                dht._log('PutValue %b', key); // create record in the dht format


                _context7.next = 4;
                return utils.createPutRecord(key, value);

              case 4:
                record = _context7.sent;
                _context7.next = 7;
                return putLocal(key, record);

              case 7:
                // put record to the closest peers
                counterAll = 0;
                counterSuccess = 0;
                _context7.next = 11;
                return utils.mapParallel(dht.getClosestPeers(key, {
                  shallow: true
                }), /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(peer) {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.prev = 0;
                            counterAll += 1;
                            _context6.next = 4;
                            return dht._putValueToPeer(key, record, peer);

                          case 4:
                            counterSuccess += 1;
                            _context6.next = 10;
                            break;

                          case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6["catch"](0);

                            dht._log.error('Failed to put to peer (%b): %s', peer.id, _context6.t0);

                          case 10:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, null, [[0, 7]]);
                  }));

                  return function (_x8) {
                    return _ref5.apply(this, arguments);
                  };
                }());

              case 11:
                // verify if we were able to put to enough peers
                minPeers = options.minPeers || counterAll; // Ensure we have a default `minPeers`

                if (!(minPeers > counterSuccess)) {
                  _context7.next = 16;
                  break;
                }

                error = errcode(new Error("Failed to put value to enough peers: ".concat(counterSuccess, "/").concat(minPeers)), 'ERR_NOT_ENOUGH_PUT_PEERS');

                dht._log.error(error);

                throw error;

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },

    /**
     * Get the value to the given key.
     * Times out after 1 minute by default.
     *
     * @param {Uint8Array} key
     * @param {object} [options] - get options
     * @param {number} [options.timeout] - optional timeout (default: 60000)
     */
    get: function get(key) {
      var _arguments2 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var options, vals, recs, i, best;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                options = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {};
                options.timeout = options.timeout || c.minute;

                dht._log('_get %b', key);

                _context8.next = 5;
                return dht.getMany(key, c.GET_MANY_RECORD_COUNT, options);

              case 5:
                vals = _context8.sent;
                recs = vals.map(function (v) {
                  return v.val;
                });
                i = 0;
                _context8.prev = 8;
                i = libp2pRecord.selection.bestRecord(dht.selectors, key, recs);
                _context8.next = 16;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8["catch"](8);

                if (!(_context8.t0.code !== 'ERR_NO_SELECTOR_FUNCTION_FOR_RECORD_KEY')) {
                  _context8.next = 16;
                  break;
                }

                throw _context8.t0;

              case 16:
                best = recs[i];

                dht._log('GetValue %b %s', key, best);

                if (best) {
                  _context8.next = 20;
                  break;
                }

                throw errcode(new Error('best value was not found'), 'ERR_NOT_FOUND');

              case 20:
                _context8.next = 22;
                return sendCorrectionRecord(key, vals, best);

              case 22:
                return _context8.abrupt("return", best);

              case 23:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[8, 12]]);
      }))();
    },

    /**
     * Get the `n` values to the given key without sorting.
     *
     * @param {Uint8Array} key
     * @param {number} nvals
     * @param {object} [options] - get options
     * @param {number} [options.timeout] - optional timeout (default: 60000)
     */
    getMany: function getMany(key, nvals) {
      var _arguments3 = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var options, vals, localRec, id, rtp, errMsg, valsLength, createQuery, query;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                createQuery = function _createQuery(pathIndex, numPaths) {
                  // This function body runs once per disjoint path
                  var pathSize = utils.pathSize(nvals - valsLength, numPaths);
                  var queryResults = 0;
                  /**
                   * Here we return the query function to use on this particular disjoint path
                   *
                   * @param {PeerId} peer
                   */

                  function disjointPathQuery(_x9) {
                    return _disjointPathQuery.apply(this, arguments);
                  }

                  function _disjointPathQuery() {
                    _disjointPathQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(peer) {
                      var rec, peers, lookupErr, results, res;
                      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while (1) {
                          switch (_context9.prev = _context9.next) {
                            case 0:
                              _context9.prev = 0;
                              _context9.next = 3;
                              return dht._getValueOrPeers(peer, key);

                            case 3:
                              results = _context9.sent;
                              rec = results.record;
                              peers = results.peers;
                              _context9.next = 13;
                              break;

                            case 8:
                              _context9.prev = 8;
                              _context9.t0 = _context9["catch"](0);

                              if (!(_context9.t0.code !== 'ERR_INVALID_RECORD')) {
                                _context9.next = 12;
                                break;
                              }

                              throw _context9.t0;

                            case 12:
                              lookupErr = _context9.t0;

                            case 13:
                              /** @type {import('../query').QueryResult} */
                              res = {
                                closerPeers: peers
                              };

                              if (rec && rec.value) {
                                vals.push({
                                  val: rec.value,
                                  from: peer
                                });
                                queryResults++;
                              } else if (lookupErr) {
                                vals.push({
                                  err: lookupErr,
                                  from: peer
                                });
                                queryResults++;
                              } // enough is enough


                              if (queryResults >= pathSize) {
                                res.pathComplete = true;
                              }

                              return _context9.abrupt("return", res);

                            case 17:
                            case "end":
                              return _context9.stop();
                          }
                        }
                      }, _callee9, null, [[0, 8]]);
                    }));
                    return _disjointPathQuery.apply(this, arguments);
                  }

                  return disjointPathQuery;
                };

                options = _arguments3.length > 2 && _arguments3[2] !== undefined ? _arguments3[2] : {};
                options.timeout = options.timeout || c.minute;

                dht._log('getMany %b (%s)', key, nvals);

                vals = [];
                _context10.prev = 5;
                _context10.next = 8;
                return getLocal(key);

              case 8:
                localRec = _context10.sent;
                _context10.next = 15;
                break;

              case 11:
                _context10.prev = 11;
                _context10.t0 = _context10["catch"](5);

                if (!(nvals === 0)) {
                  _context10.next = 15;
                  break;
                }

                throw _context10.t0;

              case 15:
                if (localRec) {
                  vals.push({
                    val: localRec.value,
                    from: dht.peerId
                  });
                }

                if (!(vals.length >= nvals)) {
                  _context10.next = 18;
                  break;
                }

                return _context10.abrupt("return", vals);

              case 18:
                _context10.next = 20;
                return utils.convertBuffer(key);

              case 20:
                id = _context10.sent;
                rtp = dht.routingTable.closestPeers(id, dht.kBucketSize);

                dht._log('peers in rt: %d', rtp.length);

                if (!(rtp.length === 0)) {
                  _context10.next = 29;
                  break;
                }

                errMsg = 'Failed to lookup key! No peers from routing table!';

                dht._log.error(errMsg);

                if (!(vals.length === 0)) {
                  _context10.next = 28;
                  break;
                }

                throw errcode(new Error(errMsg), 'ERR_NO_PEERS_IN_ROUTING_TABLE');

              case 28:
                return _context10.abrupt("return", vals);

              case 29:
                valsLength = vals.length;
                /**
                 * @param {number} pathIndex
                 * @param {number} numPaths
                 */

                // we have peers, lets send the actual query to them
                query = new Query(dht, key, createQuery);
                _context10.prev = 31;
                _context10.next = 34;
                return pTimeout(query.run(rtp), options.timeout);

              case 34:
                _context10.next = 40;
                break;

              case 36:
                _context10.prev = 36;
                _context10.t1 = _context10["catch"](31);

                if (!(vals.length === 0)) {
                  _context10.next = 40;
                  break;
                }

                throw _context10.t1;

              case 40:
                _context10.prev = 40;
                query.stop();
                return _context10.finish(40);

              case 43:
                return _context10.abrupt("return", vals);

              case 44:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[5, 11], [31, 36, 40, 43]]);
      }))();
    }
  };
};